import { atom } from 'recoil';

import { Quantity, QuantityName, SelectedFilterOption } from './types';

const uniqueAtomKey = 'Analyzer_';

export const quantitiesAtom = atom<Quantity[]>({
  key: `${uniqueAtomKey}quantities`,
  default: []
});

export const visibleQuantitiesAtom = atom<QuantityName[]>({
  key: `${uniqueAtomKey}visibleQuantities`,
  default: ['WORK_DEMAND', 'ROSTER']
});

export const initialVisibleQuantitiesAtom = atom<QuantityName[]>({
  key: `${uniqueAtomKey}initialVisibleQuantities`,
  default: ['WORK_DEMAND', 'ROSTER']
});

export const groupByAtom = atom({
  key: `${uniqueAtomKey}groupedBy`,
  default: ''
});

export const selectedCategoriesAtom = atom<SelectedFilterOption[]>({
  key: `${uniqueAtomKey}selectedCategories`,
  default: []
});

export const selectedFunctionsAtom = atom<SelectedFilterOption[]>({
  key: `${uniqueAtomKey}selectedFunctions`,
  default: []
});

export const compareWithAtom = atom<
  'WORK_DEMAND' | 'BASE_PLAN' | 'ROSTER' | ''
>({
  key: `${uniqueAtomKey}compareWith`,
  default: ''
});
